import styled from "styled-components";

export const MobileContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  width: 100%;
  height: 100vh;
  max-width: 768px;
  background-color: "#000";
  margin: 0 auto;
`;
